import { Button, Flex, Modal, Result } from 'antd'
import { ModalProps } from 'antd/lib'

import { Upload } from 'src/components'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Props = {
  onCancel: () => void
} & ModalProps

export const ImportModal = ({ onCancel, ...props }: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles()

  return (
    <Modal
      open
      centered
      maskClosable={false}
      title={t('reports_administration.import_data')}
      footer={
        <Flex justify="center" gap={16}>
          <Button onClick={onCancel}>{t('common.cancel')}</Button>
          <Button type="primary" onSubmit={onCancel}>
            {t('common.import')}
          </Button>
        </Flex>
      }
      onCancel={onCancel}
      {...props}
    >
      <Flex vertical gap={24}>
        <Result
          rootClassName={styles.resultRoot}
          className={styles.result}
          status="warning"
          title={t('reports_administration.result_title')}
        />

        <Upload maxCount={1} multiple={false} description="" />
      </Flex>
    </Modal>
  )
}
